module.exports = __webpack_public_path__ + "img/008-shirt.8bc6611b.svg";